import { useDispatch, useSelector } from "react-redux";

import { usePlanService } from "@/services/plan.service";
import {
  planSelected as planSelectedAction,
  typeOfFinancing,
} from "@/redux/actions/plans";
import { usePlansContext } from "../context/PlansContext";

export const useQuote = ({ setShowModalError }) => {
  const planSelected = useSelector((state) => state.plans.planSelected);
  const userData = useSelector((state) => state.vida.userData);
  const dispatch = useDispatch();

  const { createQuote } = usePlanService();
  const { setLoadingQuote } = usePlansContext();

  const sendQuote = async ({
    sumAssured,
    savingTime,
    returnPercentage,
    frequency,
  }) => {
    const reqSumAssured = sumAssured?.text?.replace(/[^\d]/g, "");
    const reqSavingTime = savingTime?.text?.replace(/[^\d]/g, "");
    const reqReturnPercentage = returnPercentage?.text?.replace(/[^\d]/g, "");

    setLoadingQuote(true);
    try {
      if (!reqSavingTime || !reqSumAssured || !reqReturnPercentage) {
        throw new Error("Missing required quote fields");
      }

      const payload = {
        fechaNacimiento: userData.fechaNacimiento,
        sexo: userData.sexo,
        sumaAsegurada: reqSumAssured,
        anios: reqSavingTime,
        moneda: "SOL",
        porcentajeDevolucion: reqReturnPercentage,
      };

      const response = await createQuote(payload);
      const currentPlanSelected = response[0];
      await dispatch(
        planSelectedAction({
          ...planSelected,
          ...currentPlanSelected,
          sumAssured,
          savingTime,
          returnPercentage,
          frequency,
        }),
      );
      const currentFinancing = currentPlanSelected?.plan?.financiamiento.filter(
        (item) => Number(item.numeroCuotasAnual) === frequency,
      )[0];
      await dispatch(typeOfFinancing(currentFinancing));
    } catch (error) {
      setShowModalError(true);
    } finally {
      setLoadingQuote(false);
    }
  };

  return {
    sendQuote,
  };
};
